module.exports = __webpack_public_path__ + "img/robot_sad_BOLD-01.7e8cbb5b.svg";